export const COMMUNICATION_INBOX_PATH = '/patients/messages' as const;
export const COMMUNICATION_INBOX_ALIAS_PATH = '/patients/kommunikation' as const;

/** Visible staff inbox tabs. Add `sms` here when that inbox ships. */
export const COMMUNICATION_INBOX_TABS = ['messages', 'email'] as const;

export type CommunicationInboxTab = (typeof COMMUNICATION_INBOX_TABS)[number];

export function isCommunicationInboxTab(value: string): value is CommunicationInboxTab {
  return (COMMUNICATION_INBOX_TABS as readonly string[]).includes(value);
}

export function communicationInboxTabFromParam(
  value: string | null | undefined,
): CommunicationInboxTab {
  if (value === 'email') return 'email';
  return 'messages';
}

export function communicationInboxPath(
  tab: CommunicationInboxTab = 'messages',
  opts?: { threadId?: string | null },
): string {
  const params = new URLSearchParams();
  if (tab !== 'messages') params.set('tab', tab);
  if (opts?.threadId) params.set('thread', opts.threadId);
  const query = params.toString();
  return query ? `${COMMUNICATION_INBOX_PATH}?${query}` : COMMUNICATION_INBOX_PATH;
}
